<script>
    import { onMount } from "svelte";
    import Cinema from "../components/Cinema.svelte";
    import ajaxFetch from "../services/ajaxFetch";

    let {
        errorCallback,
        variationId,
        cinemaId,
        featureIndex,
        performance,
        additionalTrackingLabels,
        cinemaInjectionContainerWidth,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state();

    let bottomPadding = 24;

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const res = await ajaxFetch(
            `/reco-core/recommendations/orderoverview/variations/${variationId}?cinemaId=${cinemaId.toUpperCase()}`
        );
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({ headline, recommendations, tracking, additionalClickTracking, metaData, featuresState } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <Cinema
        {headline}
        {recommendations}
        {tracking}
        {featureIndex}
        {additionalClickTracking}
        {featuresState}
        {cinemaInjectionContainerWidth}
        cinemaMeta={metaData}
        {performance}
        site="reco_orderOverview"
        {additionalTrackingLabels}
        {bottomPadding}
    />
{/if}
